// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"9d67bd47","328":"d0c55364","488":"9ac57712","800":"03d2594a","839":"badc4b93","945":"6c491937"}[chunkId] + ".chunk.js";
};